const myLib = require('./MyLib');
export function validate(loai, kehoach) {
    var result = {error: false};
    if(loai === 'den') {
      if (myLib.isEmpty(kehoach.MaDoiTac)) {
          result.error = true;
          result.MaDoiTac = {error: true, trangthai: 'Chưa có nơi gửi!'};
        }
    }
    if (myLib.isEmpty(kehoach.ThoiGian)) {
        result.error = true;
        result.ThoiGian = {error: true, trangthai: 'Chưa có thời gian bắt đầu'};
      }
      if (myLib.isEmpty(kehoach.NoiDung)) {
        result.error = true;
        result.NoiDung = {error: true, trangthai: 'Chưa có nội dung'};
      }      
      if (myLib.isEmpty(kehoach.MaSK)) {
        result.error = true;
        result.MaSK = {error: true, trangthai: 'Chưa có sự vụ'};
      }      
    if(loai === 'di') {
      if(myLib.isEmpty(kehoach.MaNoiNhan)) {
        result.error = true;
          result.MaNoiNhan = {error: true, trangthai: 'Chưa có nơi nhận!'};
      }
    }
    return result;
}
export function chuanHoa(action, sukien) {
  switch (action) {
      case 'abc':
          break;
    default:
      sukien.ThoiGian = sukien.ThoiGian ? new Date(sukien.ThoiGian.setMilliseconds(0)) : sukien.ThoiGian;
      break;
  }
  return sukien;
}
export function chuyenDoi(sukien, noinhans) {
  sukien.ThoiGian = myLib.fromServerTime(sukien.ThoiGian); //server dang hieu la local nen phai chuyen thanh utc
  if(sukien.MaDoiTac !== undefined && sukien.MaDoiTac !== null) {
    sukien.MaDoiTac = {value: sukien.MaDoiTac, label: sukien.TenNoiGui};
  }
  if (sukien.MaSK !== undefined && sukien !== null) {
    sukien.MaSK = {value: sukien.MaSK, label: sukien.TenSK};
  }
  if (noinhans !== undefined && noinhans.length > 0) {
    sukien.MaNoiNhan = [];
    noinhans.map((item, index) => {
      sukien.MaNoiNhan.push({value: item.MaNoiNhan, label: item.TenDoiTac});
    });
  }
  //nnoi nhan
  console.log('sukien chuyen doi', sukien);
  return sukien;
}
